import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StepNavigationProps {
  steps: string[];
  currentStep: number;
  completedSteps: Set<number>;
  onStepClick: (step: number) => void;
}

export const StepNavigation = ({ steps, currentStep, completedSteps, onStepClick }: StepNavigationProps) => (
  <nav aria-label='GMF application steps' className='space-y-2'>
    {steps.map((step, index) => {
      const isCurrent = currentStep === index;
      const isCompleted = completedSteps.has(index);

      return (
        <button
          key={step}
          type='button'
          onClick={() => onStepClick(index)}
          className={cn(
            'flex w-full cursor-pointer items-center gap-3 rounded-md px-3 py-2 text-left text-sm transition-colors',
            isCurrent && 'bg-primary text-primary-foreground',
            !isCurrent && isCompleted && 'bg-emerald-50 text-slate-950 hover:bg-emerald-100',
            !isCurrent && !isCompleted && 'text-slate-600 hover:bg-slate-100'
          )}
        >
          <span
            className={cn(
              'flex size-6 shrink-0 items-center justify-center rounded-full border text-xs font-medium',
              isCurrent && 'border-primary-foreground',
              !isCurrent && isCompleted && 'border-emerald-600 bg-emerald-600 text-white',
              !isCurrent && !isCompleted && 'border-slate-300'
            )}
          >
            {isCompleted ? <Check className='size-3.5' /> : index + 1}
          </span>
          <span className='font-medium'>{step}</span>
        </button>
      );
    })}
  </nav>
);
